import type { ReactNode } from 'react';

interface ITabItem {
  index: number;
  label: string;
  labelClassName?: string;
  children: ReactNode;
}

function TabItem(props: ITabItem) {
  return <>{props.children}</>;
}

export default TabItem;
